import type { ModalFullscreenProps } from "./modal-fullscreen.type";

import { Modal, Spin } from "antd";
import cn from "classnames";

import { useThemeBreakpoints } from "@/services/theme";

import "./modal-fullscreen.style.less";

export const ModalFullscreen = ({
  loading,
  children,
  className,
  classNames,
  ...modalProps
}: ModalFullscreenProps) => {
  const { isXs } = useThemeBreakpoints();

  return (
    <Modal
      {...modalProps}
      className={cn("modal-fullscreen", className, { "-xs": isXs })}
      classNames={{
        ...classNames,
        container: cn("modal-fullscreen--container", classNames?.container),
        body: cn("modal-fullscreen--body", classNames?.body),
      }}
    >
      {loading ? (
        <div
          className="modal-fullscreen-loader"
          data-testid="modal-fullscreen-loader"
        >
          <Spin />
        </div>
      ) : (
        <div className="modal-fullscreen-body">{children}</div>
      )}
    </Modal>
  );
};
